export * from './label.component';
export * from './label.module';
